let LOOM_URI;
let FULL_LO_DOMAIN;
let LOOM_RECORD_URI;
let COOKIE_DOMAIN;
let ANON_COOKIE_DOMAIN;
let SEARCH_INDEX;

switch (process.env.NODE_ENV) {
  case 'production':
    LOOM_URI = 'loom.com';
    FULL_LO_DOMAIN = `www.${LOOM_URI}`;
    LOOM_RECORD_URI = 'record.loom.com';
    COOKIE_DOMAIN = 'www.loom.com';
    ANON_COOKIE_DOMAIN = 'loom.com';
    SEARCH_INDEX = 'production';

    break;
  case 'staging':
    LOOM_URI = 'stage.loom.com';
    FULL_LO_DOMAIN = LOOM_URI;
    LOOM_RECORD_URI = 'record-stage.loom.com';
    COOKIE_DOMAIN = 'stage.loom.com';
    ANON_COOKIE_DOMAIN = 'stage.loom.com';
    SEARCH_INDEX = 'staging';
    break;
  default:
    LOOM_URI = process.env.NGROK_HOST || 'loomlocal.com:4444';
    FULL_LO_DOMAIN = LOOM_URI;
    COOKIE_DOMAIN = process.env.NGROK_HOST || 'loomlocal.com';
    ANON_COOKIE_DOMAIN = COOKIE_DOMAIN;
    SEARCH_INDEX = 'dev';
}

// ENV overrides if set
// end goal is to remove hardcoded values
LOOM_URI = process.env.LOOM_URI || LOOM_URI;
FULL_LO_DOMAIN = process.env.FULL_LO_DOMAIN || FULL_LO_DOMAIN;
LOOM_RECORD_URI = process.env.LOOM_RECORD_URI || LOOM_RECORD_URI;
COOKIE_DOMAIN = process.env.COOKIE_DOMAIN || COOKIE_DOMAIN;
ANON_COOKIE_DOMAIN = process.env.ANON_COOKIE_DOMAIN || ANON_COOKIE_DOMAIN;
SEARCH_INDEX = process.env.SEARCH_INDEX || SEARCH_INDEX;

const LOOM_RGXP = LOOM_URI;
const CASE_STUDIES_URI = `https://${FULL_LO_DOMAIN}/use-cases`;
const SLACK_INTEGRATION_URI =
  'https://support.loom.com/hc/en-us/articles/360002231278-Slack-Send-Loom-Videos-to-my-team-on-Slack';
const FULL_LO_URI = `https://${FULL_LO_DOMAIN}`;
const WELCOME = `${FULL_LO_DOMAIN}/welcome`;
const LOGIN = `${FULL_LO_URI}/login`;
const SIGNUP = `${FULL_LO_URI}/signup`;
const MANAGE_PLANS = `${FULL_LO_URI}/settings/workspace#plans`;

export {
  LOOM_URI,
  LOOM_RECORD_URI,
  FULL_LO_DOMAIN,
  COOKIE_DOMAIN,
  CASE_STUDIES_URI,
  SLACK_INTEGRATION_URI,
  FULL_LO_URI,
  WELCOME,
  LOGIN,
  SIGNUP,
  LOOM_RGXP,
  ANON_COOKIE_DOMAIN,
  SEARCH_INDEX,
  MANAGE_PLANS,
};
